import { SvgKey } from "../../../../assets/icons";
import { WithIconTextareaFormInput } from "../withIconTextAreaFormInput";

export const ChangePasswordForm = () => {
  return (
    <>
      <div className="d-flex flex-column px-3">
        <h6 className="mb-3 mt-1">Sign In Information</h6>
        <p className="fw-bold mt-3 card-text ms-1">Old Password</p>
        <WithIconTextareaFormInput className=" m-0 w-100" name="CurrentPassword" type="password" svgicon={SvgKey} />
        <p className="fw-bold mt-3 card-text ms-1">New Password</p>
        <WithIconTextareaFormInput className=" m-0 w-100" name="NewPassword" type="password" svgicon={SvgKey} />
        <p className="mt-1 info-text ms-2">
          {" "}
          Password must be at least 8 characters (at least 1 number and 1 capital letter).
        </p>
        <p className="fw-bold mt-3 card-text ms-1">Confirm Password</p>
        <WithIconTextareaFormInput className=" m-0 w-100" name="confPassword" type="password" svgicon={SvgKey} />
      </div>
    </>
  );
};
